import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { socket } from "../../services/socket/socket";
import { motion } from "framer-motion";

import Breadcrumb from "./../components/Breadcrumb";
import companycss from "../css/company.module.css";
import commoncss from "../css/common.module.css";
import modalcss from "../css/modal.module.css";
import buttoncss from "../css/button.module.css";
import CompanyEditSideMenu from "../components/companyedit/CompanyEditSideMenu";
import defaultCompany from "../assets/imgs/defaultCompany.png";
import AddEditCompanyModal from "./../components/mycompanies/AddEditCompanyModal";

import { getCompanybyId } from "../../Console/Component/services/apiHandler";
import { Button } from "../elements/Button";
import Modal from "../elements/Modal";
import {
  deleteCompanyData,
  getApproverForDeleteCompany,
} from "../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as DeleteIcon } from "../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import EditorWithUpload from "../components/EditorWithUpload";

const CompanyDetails = () => {
  const { companyId } = useParams();
  const [companyID, setCompanyID] = useState(companyId);
  const [companyData, setCompanyData] = useState("");
  const [editCompanyModal, setEditCompanyModal] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [deleteCompanyModal, setDeleteCompanyModal] = useState(false);

  const [companyName, setcompanyName] = useState(""); // company name

  const breadcrumbItems = [
    {
      label: "My companies",
      link: `/myfinV2/my-companies`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: companyName,
      link: `/myfinV2/company-details/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Company Details",
      link: "",
      className: "headerLable",
    },
  ];

  useEffect(() => {
    getCompanyDetails();
    getApprovalIds();
  }, [companyId]);

  const handleClose = () => {
    setDisplayModal(false);
    setEditCompanyModal(false);
  };
  const fetchCompanies = () => {
    getCompanyDetails();
  };

  const getCompanyDetails = () => {
    getCompanybyId(companyId)
      .then((response) => {
        if (response.data.getOneCompany[0]) {
          setCompanyData(response.data.getOneCompany[0]);
        }
      })
      .catch((error) => {
        setCompanyData({});
      });
  };

  const [approver, setApprover] = useState({
    approver_id: "",
  });
  const permissions = JSON.parse(localStorage.getItem("permission"));
  const user = JSON.parse(localStorage.getItem("user"));
  const [approvalId, setApprovalId] = useState([]);

  const getApprovalIds = async () => {
    const parent_id = user.parent_id;
    getApproverForDeleteCompany(parent_id)
      .then((response) => {
        setApprovalId(response.data.result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const deleteCompany = async () => {
    const data = {
      companyName: companyData.company_name,
      companyCode: companyData.company_code,
      ci_no: companyData.ci_no,
      pan_no: companyData.pan_no,
      nature_of_company: companyData.nature_of_company,
      functional: companyData.functional,
      city: companyData.city,
      state: companyData.state,
      address: companyData.address,
      has_published: "draft",
      status: "waiting",
      approver_id: approver.approver_id,
      preparer_id: user._id,
    };
    const res = await deleteCompanyData(companyData._id, data);
    if (res.status === 200) {
      if (user.responsibilities === "preparer") {
        socket.emit("add-notification", {
          receiver_id: approver.approver_id,
          description: "deletion of company",
          type: "sent approval",
          path: "/Notification",
        });
        socket.emit("get-notification");
      }
      window.location.href = `/myfinv2/my-companies`;
    }
    if (res.data.error) {
      swal("", res.data.error, "error");
    }
  };
  return (
    <div className={`${companycss.subContainer}`}>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <CompanyEditSideMenu
          activeTab={"Company Details"}
          companyID={companyID}
          companyDataCheck={true}
          setcompanyName={setcompanyName}
        />
      </motion.div>
      <motion.div
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 200, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        className="w-100"
      >
        <div className={companycss.subContainer__}>
          <Breadcrumb
            addCls={commoncss.bgClr1}
            items={breadcrumbItems}
            headerActions={<></>}
          />
          {/* <HeaderWhenSecondSideBarActive
                    title="Company Details"
                    secondaryBtnText="Cancel"
                    primaryBtnText="Save"
                /> */}
          {companyData && (
            <div className={companycss.subMainContainer}>
              <div className={companycss.container}>
                <div className={commoncss.dFlexJustifysb}>
                  <div className={commoncss.dFlex}>
                    {companyData?.logo?.url ? (
                      <img
                        className="mr-3"
                        src={companyData.logo.url}
                        width={100}
                        alt="Company Logo"
                      />
                    ) : (
                      <img
                        src={defaultCompany}
                        height={120}
                        alt="Company Logo"
                      />
                    )}
                    <div className={commoncss.dFlexClm}>
                      <span className={companycss.cmpLabel1}>
                        {companyData.company_name}
                      </span>
                      <span className={companycss.cmpLabel2}>
                        {companyData.nature_of_company}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span
                      className={`${companycss.cmpLabel2} ${commoncss.clickable}`}
                      style={{ color: "#E30000" }}
                      onClick={() => {
                        if (
                          permissions?.unrestrictedAcessData[0]?.permission
                            ?.delete === false
                        ) {
                          swal(
                            "Warning",
                            "You Don't have Permission to delete Company ",
                            "warning"
                          );
                        } else if (
                          (user.responsibilities === "preparer" &&
                            companyData.created_by === "admin") ||
                          (user.responsibilities === "preparer" &&
                            companyData.user_id !== user._id)
                        ) {
                          swal(
                            "Warning",
                            "You Don't have Access to delete Company ",
                            "warning"
                          );
                        } else if (user.responsibilities === "preparer") {
                          swal(
                            "Warning",
                            "You Don't have Access to delete Company ",
                            "warning"
                          );
                        } else if (
                          user.responsibilities === "approver" ||
                          user.responsibilities === "view"
                        ) {
                          swal(
                            "Warning",
                            "You Don't have Access to delete Company ",
                            "warning"
                          );
                        } else {
                          setDeleteCompanyModal(true);
                          setDisplayModal(true);
                        }
                      }}
                    >
                      Delete Company
                    </span>
                    <span
                      className={`${companycss.cmpLabel2} ${commoncss.clickable} ml-5`}
                      style={{ color: "#2D8861" }}
                      onClick={() => {
                        setDisplayModal(true);
                        setEditCompanyModal(true);
                      }}
                    >
                      Edit Company
                    </span>
                  </div>
                </div>
                <hr className="my-4" />
                <div
                  className="d-flex"
                  style={{ gap: "280px", "align-items": "flex-start" }}
                >
                  <div className={commoncss.dFlex}>
                    <div className={commoncss.dFlexClm}>
                      <span className={companycss.cmpLabel3}>
                        Company Details
                      </span>
                      <span className={companycss.cmpLabel4}>
                        Basic information about the company
                      </span>
                    </div>
                  </div>
                  <div className={commoncss.dFlexClm} style={{ gap: "7px" }}>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          Organization Name
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.company_name}
                        </span>
                      </div>
                    </div>

                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          Nature of Company
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.nature_of_company}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div
                  className="d-flex"
                  style={{ gap: "261px", "align-items": "flex-start" }}
                >
                  <div className={commoncss.dFlex}>
                    <div className={commoncss.dFlexClm}>
                      <span className={companycss.cmpLabel3}>Identifiers</span>
                      <span className={companycss.cmpLabel4}>
                        Key registration and identification details
                      </span>
                    </div>
                  </div>
                  <div className={commoncss.dFlexClm} style={{ gap: "7px" }}>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          Functional currency
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.functional}
                        </span>
                      </div>
                    </div>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          CIN No.
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.ci_no}
                        </span>
                      </div>
                    </div>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          PAN/TAX No.
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.pan_no}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div
                  className="d-flex"
                  style={{ gap: "289px", "align-items": "flex-start" }}
                >
                  <div className={commoncss.dFlex}>
                    <div className={commoncss.dFlexClm}>
                      <span className={companycss.cmpLabel3}>
                        Location Details
                      </span>
                      <span className={companycss.cmpLabel4}>
                        Official city and state of registration
                      </span>
                    </div>
                  </div>
                  <div className={commoncss.dFlexClm} style={{ gap: "7px" }}>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          City
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.city}
                        </span>
                      </div>
                    </div>
                    <div className={commoncss.dFlexClm}>
                      <div className="d-flex" style={{ gap: "30px" }}>
                        <span
                          className={companycss.cmpLabel5}
                          style={{ width: "150px" }}
                        >
                          State
                        </span>
                        <span className={companycss.cmpLabel6}>
                          {companyData.state}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <EditorWithUpload /> */}
              </div>

              {editCompanyModal && displayModal && (
                <AddEditCompanyModal
                  handleClose={handleClose}
                  fetchCompanies={fetchCompanies}
                  companyData={companyData}
                />
              )}

              {deleteCompanyModal && displayModal && (
                <Modal
                  headerActions={
                    <CloseIcon
                      onClick={() => {
                        handleClose();
                        setDeleteCompanyModal(false);
                      }}
                      className="clickable"
                    />
                  }
                  headerBottomLine={false}
                  onClose={() => console.log("Modal Closed")}
                >
                  <span className={`${modalcss.modalBodyHead} mb-1`}>
                    Do you want to <span className="fw700">delete</span> the
                    company?
                  </span>
                  <span
                    className={`${modalcss.modalBodycnt}`}
                    style={{ "margin-bottom": "35px" }}
                  >
                    Once deleted, you cannot restore the company
                  </span>
                  <span
                    className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
                  >
                    <Button
                      btnColor={buttoncss.danger}
                      label="Delete"
                      icon={<DeleteIcon width={20} height={20} />}
                      onClick={() => {
                        deleteCompany();
                      }}
                    />
                    <Button
                      btnColor={buttoncss.secondary_del}
                      label="Cancel"
                      onClick={() => {
                        handleClose();
                        setDeleteCompanyModal(false);
                      }}
                    />
                  </span>
                </Modal>
              )}
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default CompanyDetails;
